import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=23c419de&scoped=true"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=23c419de&prod&scoped=true&lang=css"
import style1 from "./ProjectLayout.vue?vue&type=style&index=1&id=23c419de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c419de",
  null
  
)

export default component.exports